export default "__VITE_ASSET__CXsrf56l__"